import React, { useEffect, useState } from 'react';
import './PopUp.css';

const PopupModal = ({ isOpen, title, message, showOk, showCancel, onClose }) => {
  const [visible, setVisible] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      // Defer animation trigger slightly to allow DOM render first
      setTimeout(() => setAnimateIn(true), 10);
    } else {
      setAnimateIn(false); // trigger fade/slide-out
      const timer = setTimeout(() => setVisible(false), 300); // matches CSS
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen && !visible) return null;

  return (
    <div className={`popup-overlay ${animateIn ? 'fade-in' : 'fade-out'}`}>
      <div className={`popup-container ${animateIn ? 'slide-in' : 'slide-out'}`}>
        {title && <h2 className="popup-title">{title}</h2>}
        {message && <p className="popup-message">{message}</p>}

        <div className="popup-buttons">
          {showCancel && (
            <button className="popup-btn cancel" onClick={() => onClose('cancel')}>
              Cancel
            </button>
          )}
          {showOk && (
            <button className="popup-btn ok" onClick={() => onClose('ok')}>
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
